// extracted by mini-css-extract-plugin
module.exports = {"LoadingPage":"LoadingPage_LoadingPage__3LoCb","content":"LoadingPage_content__3yL12","spinner":"LoadingPage_spinner__OpV_V"};